import { render } from "./V6.vue?vue&type=template&id=a2e7d276"
import script from "./V6.vue?vue&type=script&lang=ts"
export * from "./V6.vue?vue&type=script&lang=ts"
script.render = render

export default script